import { safeParseNullDefault, safeParse } from 'shouldve-been-js';

class KFleetToken {

    private _token: string | null;
    private _refreshToken: string | null;
    private _userId: string | null;
    private _username: string | null;
    private _email: string | null;
    private _access: string[] | null;
    private _expiration: Date | null;

    public constructor(token: string | null, refreshToken: string | null, userId: string | null, username: string | null, email: string | null, access: string[] | null, expiration: Date | null) {

        this._token = token;
        this._refreshToken = refreshToken;
        this._userId = userId;
        this._username = username;
        this._email = email;
        this._access = access;
        this._expiration = expiration;
    }

    public get token(): string | null {
        return this._token;
    }

    public set token(value: string | null) {
        this._token = value;
    }

    public get refreshToken(): string | null {
        return this._refreshToken;
    }

    public set refreshToken(value: string | null) {
        this._refreshToken = value;
    }

    public get userId(): string | null {
        return this._userId;
    }

    public set userId(value: string | null) {
        this._userId = value;
    }

    public get username(): string | null {
        return this._username;
    }

    public set username(value: string | null) {
        this._username = value;
    }

    public get email(): string | null {
        return this._email;
    }

    public set email(value: string | null) {
        this._email = value;
    }

    public get access(): string[] | null {
        return this._access;
    }

    public set access(value: string[] | null) {
        this._access = value;
    }

    public get expiration(): Date | null {
        return this._expiration;
    }

    public set expiration(value: Date | null) {
        this._expiration = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): KFleetToken {

        const token: string | null = safeParseNullDefault<string>(json?.Token, '');
        const refreshToken: string | null = safeParseNullDefault<string>(json?.Claims?.RefreshToken, '');
        const userId: string | null = safeParseNullDefault<string>(json?.Claims?.sub, '');
        const username: string | null = safeParseNullDefault<string>(json?.Claims?.UserName, '');
        const email: string = safeParse<string>(json?.Claims?.Email, '');
        const access: string[] | null = safeParseNullDefault<string>(json?.Claims?.Permissions, '')?.split(',') ?? null;
       
        const expirationSeconds: number | null = safeParseNullDefault<number>(json?.Claims.exp, 0);
        const expirationMillis: number | null = expirationSeconds === null ? null : expirationSeconds * 1000;
        const expiration: Date | null = expirationMillis === null ? null : new Date(expirationMillis);

        return new KFleetToken(token, refreshToken, userId, username, email, access, expiration);
    }
}

export default KFleetToken;